// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/address/v1/address.proto" (package "agency.address.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * NodeID uniquely identifies a harness node in the distributed system.
 *
 * @generated from protobuf message agency.address.v1.NodeID
 */
export interface NodeID {
    /**
     * region is the geographical or logical region (e.g., "us-east", "eu-west").
     *
     * @generated from protobuf field: string region = 1
     */
    region: string;
    /**
     * kind is the type of node.
     *
     * @generated from protobuf field: agency.address.v1.NodeKind kind = 2
     */
    kind: NodeKind;
    /**
     * instance is the unique instance identifier within the region and kind.
     *
     * @generated from protobuf field: string instance = 3
     */
    instance: string;
}
/**
 * ActorAddress is the universal actor addressing scheme.
 * Format: urn.<region>.<kind>.<instance>.<tenant>.<workspace>.<session>.<role>
 *
 * @generated from protobuf message agency.address.v1.ActorAddress
 */
export interface ActorAddress {
    /**
     * node identifies the harness node.
     *
     * @generated from protobuf field: agency.address.v1.NodeID node = 1
     */
    node?: NodeID;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the primary grouping boundary within a tenant.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * session is the session identifier (optional for workspace-scoped actors).
     *
     * @generated from protobuf field: string session = 4
     */
    session: string;
    /**
     * role is the actor role (e.g., "orchestrator", "tool.web_search", "memory").
     *
     * @generated from protobuf field: string role = 5
     */
    role: string;
}
/**
 * NodeKind represents the type of node in the distributed system.
 *
 * @generated from protobuf enum agency.address.v1.NodeKind
 */
export enum NodeKind {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: NODE_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * CLOUD represents a cloud-hosted harness node.
     *
     * @generated from protobuf enum value: NODE_KIND_CLOUD = 1;
     */
    CLOUD = 1,
    /**
     * ONPREM represents an on-premises harness node.
     *
     * @generated from protobuf enum value: NODE_KIND_ONPREM = 2;
     */
    ONPREM = 2,
    /**
     * EDGE represents an edge computing node.
     *
     * @generated from protobuf enum value: NODE_KIND_EDGE = 3;
     */
    EDGE = 3,
    /**
     * IOT represents an IoT gateway node.
     *
     * @generated from protobuf enum value: NODE_KIND_IOT = 4;
     */
    IOT = 4,
    /**
     * MOBILE represents a mobile device node.
     *
     * @generated from protobuf enum value: NODE_KIND_MOBILE = 5;
     */
    MOBILE = 5,
    /**
     * WASM represents a WebAssembly runtime node.
     *
     * @generated from protobuf enum value: NODE_KIND_WASM = 6;
     */
    WASM = 6,
    /**
     * LOCAL represents a local development node.
     *
     * @generated from protobuf enum value: NODE_KIND_LOCAL = 7;
     */
    LOCAL = 7
}
// @generated message type with reflection information, may provide speed optimized methods
class NodeID$Type extends MessageType<NodeID> {
    constructor() {
        super("agency.address.v1.NodeID", [
            { no: 1, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "kind", kind: "enum", T: () => ["agency.address.v1.NodeKind", NodeKind, "NODE_KIND_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "instance", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<NodeID>): NodeID {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.region = "";
        message.kind = 0;
        message.instance = "";
        if (value !== undefined)
            reflectionMergePartial<NodeID>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NodeID): NodeID {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string region */ 1:
                    message.region = reader.string();
                    break;
                case /* agency.address.v1.NodeKind kind */ 2:
                    message.kind = reader.int32();
                    break;
                case /* string instance */ 3:
                    message.instance = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NodeID, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string region = 1; */
        if (message.region !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.region);
        /* agency.address.v1.NodeKind kind = 2; */
        if (message.kind !== 0)
            writer.tag(2, WireType.Varint).int32(message.kind);
        /* string instance = 3; */
        if (message.instance !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.instance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.address.v1.NodeID
 */
export const NodeID = new NodeID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorAddress$Type extends MessageType<ActorAddress> {
    constructor() {
        super("agency.address.v1.ActorAddress", [
            { no: 1, name: "node", kind: "message", T: () => NodeID, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "session", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9._-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<ActorAddress>): ActorAddress {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.session = "";
        message.role = "";
        if (value !== undefined)
            reflectionMergePartial<ActorAddress>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorAddress): ActorAddress {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.address.v1.NodeID node */ 1:
                    message.node = NodeID.internalBinaryRead(reader, reader.uint32(), options, message.node);
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string session */ 4:
                    message.session = reader.string();
                    break;
                case /* string role */ 5:
                    message.role = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorAddress, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.address.v1.NodeID node = 1; */
        if (message.node)
            NodeID.internalBinaryWrite(message.node, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string session = 4; */
        if (message.session !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.session);
        /* string role = 5; */
        if (message.role !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.role);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.address.v1.ActorAddress
 */
export const ActorAddress = new ActorAddress$Type();
